import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environmentConfigs } from './environments/environment-config';
import { getAppDomain, getEnvironmentIdentifier } from './environments/get-environment-identifier';

const identifier = getEnvironmentIdentifier();
const baseEnvironment = environmentConfigs[identifier] || environmentConfigs['dev'];
const environment = {
  ...baseEnvironment,
  AppDomain: getAppDomain(identifier),
};

(window as any).environment = environment;

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule, {
    applicationProviders: [provideZoneChangeDetection()],
  })
  .catch((err) => console.error(err));
